export const videoConferencingToolsApiHandler = {
  getVideoConferencingTools: {
    method: "GET",
    path: () => `video-conferencing-tools`
  }
};